import React, { Component } from "react";
import classNames from "classnames";
import { string, func, bool, int, shape } from "prop-types";
import { connect } from "react-redux";

import { actions as productsActions } from "reducers/products";
import Col from "react-bootstrap/lib/Col";
import { push } from "react-router-redux";
import EditableLabel from "pages/_components/fields/EditableLabel";
import { Button as ButtonSB } from "@ui-kit/components/index.es";
import { actions as accountsActions } from "reducers/accounts";
import { maskedAccountNumber, productTypes, accountContextMenuItems } from "util/accounts";
import ContextMenu from "pages/_components/ContextMenu";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as settingsSelectors } from "reducers/settings";

import * as i18nUtils from "util/i18n";
import * as config from "util/config";

class DetailHeadTitle extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
        account: shape({
            idEnvironment: int,
            idProduct: string,
            productType: string.isRequired,
            productAlias: string,
            label: string,
            shortLabel: string,
            extraInfo: string,
            number: string.isRequired,
            ownerName: string,
            currency: string.isRequired,
            extraInfoMarked: string,
            favorite: bool,
        }).isRequired,
        activeEnvironment: shape({}).isRequired,
        hideAmount: bool.isRequired,
        setShowPartialAmounts: func.isRequired,
        showPartialAmounts: bool.isRequired,
        embeddedInV3Shell: bool,
        contextMenuEntryPathname: string,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        contextMenuEntryPathname: undefined,
    };

    constructor(props) {
        super(props);
        this.titleRef = React.createRef();
        this.state = {
            isHorizontalTable: false,
        };

        this.updatePredicate = this.updatePredicate.bind(this);
    }

    componentDidMount() {
        if (this.titleRef.current) {
            this.titleRef.current.focus();
        }
        this.updatePredicate();
        window.addEventListener("resize", this.updatePredicate);
    }

    componentDidUpdate() {
        if (this.titleRef.current) {
            this.titleRef.current.focus();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updatePredicate);
    }

    saveAlias = (alias) => {
        const { account, dispatch } = this.props;
        dispatch(productsActions.changeProductAlias(alias, account.idProduct));
    };

    gotoProyectedBalance = () => {
        const { account, dispatch } = this.props;

        dispatch(push(`/account/proyectedBalance/${account.idProduct}`));
        if (account.number) {
            dispatch(accountsActions.proyectedBalance(account.idProduct));
            dispatch(accountsActions.diferedMovements(account.idProduct, "1"));
        }
    };

    gotoSetProductAlias = () => {
        const { account, dispatch } = this.props;
        dispatch(push(`/account/${account.idProduct}/setProductAlias`));
    };

    updatePredicate() {
        this.setState({ isHorizontalTable: window.innerWidth >= 861 && window.innerWidth <= 1080 });
    }

    render() {
        const {
            account,
            isDesktop,
            dispatch,
            activeEnvironment,
            hideAmount,
            setShowPartialAmounts,
            showPartialAmounts,
            embeddedInV3Shell,
            contextMenuEntryPathname,
        } = this.props;
        const { number, productAlias, productType, favorite, idProduct } = account;
        const { isHorizontalTable } = this.state;
        const enableHideAmounts = config.getBoolean("frontend.hide.accounts.balance.funcionalities", false);

        let arrayItemsDropdown = [];

        if (isDesktop) {
            if (isHorizontalTable) {
                arrayItemsDropdown = [
                    {
                        label: "accounts.projected.balance",
                        onClick: () => this.gotoProyectedBalance(),
                    },
                    {
                        label: "accounts.historic.balance",
                        onClick: () => dispatch(push(`/account/historicBalance/${account.idProduct}`)),
                    },
                ];
            }
        } else {
            arrayItemsDropdown = [
                {
                    label: "products.alias.account.edit.title.mobile",
                    onClick: () => dispatch(push(`/account/${account.idProduct}/setProductAlias`)),
                    icon: "Pencil",
                },
                {
                    label: "accounts.projected.balance",
                    onClick: () => this.gotoProyectedBalance(),
                    icon: "StocksUp",
                },
                {
                    label: "accounts.historic.balance",
                    onClick: () => dispatch(push(`/account/historicBalance/${account.idProduct}`)),
                    icon: "MemoMoney",
                },
            ];
        }

        const proyectedButton = (
            <ButtonSB
                onClick={this.gotoProyectedBalance}
                variant="outline"
                text={i18nUtils.get("accounts.projected.balance")}
            />
        );
        const historicButton = (
            <ButtonSB
                variant="outline"
                text={i18nUtils.get("accounts.historic.balance")}
                onClick={() => dispatch(push(`/account/historicBalance/${account.idProduct}`))}
            />
        );

        const accountType = `accounts.productType.${productTypes[productType]}`;
        const accountTypeFormatted = i18nUtils.get(accountType);

        const title = productAlias || (
            <>
                <span>{maskedAccountNumber(number)}</span>
            </>
        );

        let mobileHeadToolbar = null;
        if (!isDesktop && !embeddedInV3Shell) {
            mobileHeadToolbar = (
                <>
                    <div className="view-title toolbar-item mt-0 mx-5 title-account-header-multiline-background-blue justify-content-center">
                        <span className="title-content header-mobile-title-background-blue">{title}</span>
                        <p>
                            <span>{accountTypeFormatted.toUpperCase()} </span>
                            <span>Nº {maskedAccountNumber(number)}</span>
                        </p>
                    </div>
                    <div className="toolbar-item">
                        {enableHideAmounts && hideAmount && (
                            <ButtonSB
                                aria-label="Mostrar saldos durante 3 segundos"
                                icon={!showPartialAmounts ? "EyeOff" : "Eye"}
                                iconVariant="outline"
                                onClick={() => {
                                    setShowPartialAmounts(true);
                                    setTimeout(() => {
                                        setShowPartialAmounts(false);
                                    }, 3000);
                                }}
                                className="z-index-200 px-2"
                            />
                        )}
                        <ContextMenu
                            isDesktop={isDesktop}
                            color="white"
                            items={accountContextMenuItems(
                                dispatch,
                                activeEnvironment,
                                idProduct,
                                arrayItemsDropdown,
                                contextMenuEntryPathname,
                            )}
                        />
                    </div>
                </>
            );
        } else if (!isDesktop && embeddedInV3Shell) {
            mobileHeadToolbar = <></>;
        }

        return (
            <>
                {isDesktop ? (
                    <Col sm={12} md={6} lg={6} className="pl-0 account-detail-head__title-col">
                        <EditableLabel
                            isDesktop={isDesktop}
                            favorite={favorite}
                            onSave={this.saveAlias}
                            value={productAlias || maskedAccountNumber(number)}>
                            <h1 className="my-0 title-content">{title}</h1>
                        </EditableLabel>
                    </Col>
                ) : (
                    mobileHeadToolbar
                )}

                {isHorizontalTable ? (
                    <>
                        <Col
                            sm={12}
                            md={6}
                            lg={6}
                            className={classNames("content-data-wrapper col col-12 data-wrapper-flex", {
                                "padding-right-2":
                                    accountContextMenuItems(
                                        dispatch,
                                        activeEnvironment,
                                        idProduct,
                                        [],
                                        contextMenuEntryPathname,
                                    ).length === 0,
                            })}>
                            <div className="data-wrapper-flex d-flex w-100 justify-content-end context-menu-horizontal-table">
                                <ContextMenu
                                    isDesktop={isDesktop}
                                    items={accountContextMenuItems(
                                        dispatch,
                                        activeEnvironment,
                                        idProduct,
                                        arrayItemsDropdown,
                                        contextMenuEntryPathname,
                                    )}
                                />
                            </div>
                        </Col>
                        <Col sm={12} className="content-data-wrapper mb-3 px-0 account-detail-head__meta-col">
                            <p className="account-display-font my-0 account-detail-head__meta">
                                <span className="account-detail-head__meta-type">
                                    {accountTypeFormatted.toUpperCase()}
                                </span>
                                <span className="account-detail-head__meta-number">
                                    Nº {maskedAccountNumber(number)}
                                </span>
                            </p>
                        </Col>
                    </>
                ) : (
                    <>
                        {isDesktop && (
                            <>
                                <Col
                                    sm={12}
                                    md={6}
                                    lg={6}
                                    className={classNames("content-data-wrapper col col-12 data-wrapper-flex", {
                                        "padding-right-2":
                                            accountContextMenuItems(
                                                dispatch,
                                                activeEnvironment,
                                                idProduct,
                                                [],
                                                contextMenuEntryPathname,
                                            ).length === 0,
                                    })}>
                                    <div className="data-wrapper-flex d-flex w-100 justify-content-end gap-2">
                                        {proyectedButton}
                                        {historicButton}
                                        <ContextMenu
                                            isDesktop={isDesktop}
                                            newContextMenuClassName="mr-25"
                                            items={accountContextMenuItems(
                                                dispatch,
                                                activeEnvironment,
                                                idProduct,
                                                arrayItemsDropdown,
                                                contextMenuEntryPathname,
                                            )}
                                        />
                                    </div>
                                </Col>
                                <Col sm={12} className="mb-3 px-0 account-detail-head__meta-col">
                                    <p className="account-display-font my-0 account-detail-head__meta">
                                        <span className="account-detail-head__meta-type">
                                            {accountTypeFormatted.toUpperCase()}
                                        </span>
                                        <span className="account-detail-head__meta-number">
                                            Nº {maskedAccountNumber(number)}
                                        </span>
                                    </p>
                                </Col>
                            </>
                        )}
                    </>
                )}
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    hideAmount: settingsSelectors.getUserData(state)?.hideBalance,
});
export default connect(mapStateToProps)(DetailHeadTitle);
